import React,{ useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from "react-router-dom";
import { TableCell, TableRow } from '@mui/material';
import { FileDownload } from '@mui/icons-material';

import { getSettlementsRequest, exportSettlements } from '../../../../../store/OutstandingBalance/actions';
import { getExportTransactionsRequest, getExportSingleSettlementRequest } from '../../../../../store/PaymentTransactions/actions'
import { timeConverter } from "../../../../../utils/Helpers";
import messages from '../../../../../assets/locale/messages';
import EmptyState from '../../../../../components/EmptyState';
import Table from '../../../../../components/Table';
import Pagination from '../../../../../components/Pagination';
import Button from '../../../../../components/Button';
import './Settlements.scss'

const Settlements = () => {
    const dispatch = useDispatch();
    const { id } = useParams();
    const lang = useSelector((state) => state.locale.lang);
    const isLoading = useSelector((state) => state.loader);
    const settlementsList = useSelector((state) => state.outstandingBalance.settlements);
    const meta = useSelector((state) => state.outstandingBalance.settlementsMeta);
    const { outStandingBalance, shared } = messages[lang];
    const [page, setPage] = useState(1);

    useEffect(()=>{
        dispatch(getSettlementsRequest({
            service_provider_id: id,
            page:page,
            items: 10
        }))
    },[page, lang]);

    // const handleExportTransactions = (id) => {
    //   dispatch(getExportTransactionsRequest({
    //       settlement_id:id
    //   }))
    // };

    const handleExportSingleSettlement = (id) => {
      dispatch(getExportSingleSettlementRequest(id))
    };

    const handleExportSettlements = () => {
      dispatch(exportSettlements({
        service_provider_id:id,
        page:-1
      }))
    };

    const renderSettlementsList = () => {
        if(!isLoading && settlementsList?.length === 0){
            return(
                <div className="bg-white rounded-4 categoriess-page d-flex justify-content-center align-items-center flex-column">
                    <EmptyState
                    subTitle={outStandingBalance.settlements.emptyState}
                    showActionButton={false}
                    NoDataListWithNoActionBtn={true}
                    />
              </div>
            )
        }else{
            return(
                <div className="bg-white rounded-4 mx-4 settlements-table-list">
                  <Table
                  className="bg-light-blue"
                    headlines={[
                      outStandingBalance.settlements.date,
                      outStandingBalance.settlements.time,
                      outStandingBalance.settlements.startDate,
                      outStandingBalance.settlements.endDate,
                      outStandingBalance.settlements.status,
                      outStandingBalance.settlements.settlementAmount
                    ]}
                    hasActions={true}
                    rows={settlementsList?.map((row, i) => (
                      <TableRow key={i}>
                        {/* Date */}
                        <TableCell className="font-regular text-dark-blue fsize-14">
                          {row.date}
                        </TableCell>
                        {/* Time */}
                        <TableCell className="font-regular text-dark-blue fsize-14 ">
                          {timeConverter(row.time,lang)}
                        </TableCell>
                        {/* Start date */}
                        <TableCell className="font-regular text-dark-blue fsize-14 ">
                          {row.date_from}
                        </TableCell>
                        {/* End date */}
                        <TableCell className="font-regular text-dark-blue fsize-14 ">
                          {row.date_to}
                        </TableCell>
                        {/* Status */}
                        <TableCell className="font-regular text-dark-blue fsize-14 ">
                          {row.status}
                        </TableCell>
                        {/* Amount */}
                        <TableCell className="font-regular text-dark-blue fsize-14 ">
                          {row.settlement_amount}
                        </TableCell>
                        <TableCell className="font-regular text-dark-blue fsize-14 ">
                          <u
                            className="pointer"
                            onClick={() => {handleExportSingleSettlement(row.id)}}
                          >
                            {outStandingBalance.settlements.exportTransactions}
                          </u>
                        </TableCell>
                      </TableRow>
                    ))}
                  />
                  <div className="d-flex justify-content-center py-3">
                    {meta?.pages > 1 && (
                      <Pagination
                        count={meta?.pages}
                        page={meta?.currentPage || page}
                        handleChange={(event, page) => {
                        setPage(page);
                         }}
                        defaultPage={1}
                      />
                    )} 
                  </div>
                </div>
            )
        }
    };

    return(
        <div className="settlements-page p-2">
            <div className="fsize-24 fweight-600 text-primary m-3 d-flex justify-content-between flex-wrap">
              {outStandingBalance.settlements.pageTitle}
              {!!settlementsList?.length && (
                <Button
                  label={
                    <div className="d-flex gap-1">
                      <FileDownload />
                      <span>{outStandingBalance.settlements.exportSettlements}</span>
                    </div>
                  }
                  outlined
                  color="info"
                  className="fsize-14 align-self-center"
                  onClick={()=>{handleExportSettlements()}}
                />
              )}
            </div> 
            {renderSettlementsList()}
        </div>
    )
}

export default Settlements;